import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();

  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };

  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>

      <section className="terms-usage">
        <p>
          By shopping at NeuCraft<span style={tmStyle}>™</span>, you agree to the following:
        </p>
        <ul>
          <li>All products are described as accurately as possible; minor variations are a natural part of handmade and custom-crafted items.</li>
          <li>Due to the custom nature of our products and the cost of packaging, <strong>we do not accept returns or exchanges</strong>. All sales are final.</li>
          <li>Orders are processed promptly. Please contact us immediately if you need to request a change or cancellation before the order ships.</li>
        </ul>
      </section>

      <section className="terms-contact">
        <h2>Contact</h2>
        <p>
          For questions about these terms, please contact <a href="mailto:support@neucraft.shop">support@neucraft.shop</a>.
        </p>
      </section>

      <div className="productpage-actions productpage-actions-row" style={{ justifyContent: 'flex-start', marginTop: '80px' }}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{ cursor: 'pointer' }}>
          &larr; Home
        </button>
      </div>
    </div>
  );
}